import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=7bf623b3&scoped=true&"
import script from "./CalendarView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=7bf623b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf623b3",
  null
  
)

export default component.exports